import { checkArray } from '../../../../Components/helper';

export default function useSinglePackedUnits() {
  const calculateSinglePackedUnits = async (data) => {
    const cloneSinglePackedUnit = data;
    if (checkArray(cloneSinglePackedUnit?.singularPackedRows)) {
      cloneSinglePackedUnit.totalSize = calcDiffSize(cloneSinglePackedUnit?.singularPackedRows);
      cloneSinglePackedUnit.totalLength = calcDiffLength(cloneSinglePackedUnit?.singularPackedRows);
      cloneSinglePackedUnit.totalQuantity = calcQuanity(cloneSinglePackedUnit?.singularPackedRows);
      cloneSinglePackedUnit.totalPriceBeforeDisc = calcBeforePrice(cloneSinglePackedUnit?.singularPackedRows);
      cloneSinglePackedUnit.totalDiscountPerUnit = calcDiscPrice(cloneSinglePackedUnit?.singularPackedRows);
      for (const singular of cloneSinglePackedUnit?.singularPackedRows ?? []) {
        const persentageValue = (Number(singular?.beforeDiscPrice) * Number(singular?.discount || 0)) / 100;
        singular.afterDiscPrice = (singular?.beforeDiscPrice ?? 0) - persentageValue;
      }
      cloneSinglePackedUnit.totalPriceAfterDisc = calcAfterPrice(cloneSinglePackedUnit?.singularPackedRows);
    }
    return cloneSinglePackedUnit;
  };

  function calcDiffSize(packedRows) {
    const rowSizes = packedRows
      .map((row) => row.size)
      .filter((size, index, self) => {
        return self.indexOf(size) === index && size !== undefined;
      });
    return rowSizes.length;
  }

  function calcDiffLength(packedRows) {
    const rowSizes = packedRows
      .map((row) => (row.hasOwnProperty('length') ? row.length.name : ''))
      .filter((length, index, self) => {
        return self.indexOf(length) === index && length !== '';
      });
    return rowSizes.length;
  }

  function calcQuanity(packedRows) {
    const rowQuantity = packedRows
      .map((row) => row.quantity)
      .reduce((a, b) => {
        return Number(a) + Number(isNaN(b) ? 0 : b);
      }, 0);
    return isNaN(rowQuantity) ? 0 : rowQuantity;
  }

  function calcBeforePrice(packedRows) {
    const brforePricesTotals = packedRows.map((row) => {
      const priceBeforeDisc = row.beforeDiscPrice && !isNaN(row.beforeDiscPrice) ? parseFloat(row.beforeDiscPrice) : 0;
      const quantity = row.quantity && !isNaN(row.quantity) ? parseFloat(row.quantity) : 0;

      return toDec(priceBeforeDisc * quantity);
    });
    const beforePrice = brforePricesTotals
      .map((row) => row)
      .reduce((a, b) => {
        return parseFloat(a) + parseFloat(isNaN(b) ? 0 : b);
      }, 0);
    return isNaN(beforePrice) ? 0 : limitTofourDecimal(beforePrice);
  }

  function toDec(x) {
    return isNaN(x) ? '' : Number.parseFloat(x).toFixed(3);
  }

  const limitTofourDecimal = (input) => {
    const no = !isNaN(input) ? parseFloat(input) : input;
    return no && !isNaN(no) ? toDec(parseFloat(no.toFixed(4))) : no;
  };

  function calcDiscPrice(packedRows) {
    let discountCnt = packedRows.filter((row) => row.discount && row.discount !== '' && Number(row.discount) !== 0);
    discountCnt = discountCnt.map((val) => String(val.discount));
    discountCnt = [...new Set(discountCnt)];
    discountCnt = discountCnt?.length ? discountCnt?.length : 0;
    return discountCnt;
  }

  function calcAfterPrice(packedRows) {
    const afterPricesTotals = packedRows.map((row) => {
      const priceAfterDisc = row.afterDiscPrice && !isNaN(row.afterDiscPrice) ? parseFloat(row.afterDiscPrice) : 0;
      const quantity = row.quantity && !isNaN(row.quantity) ? parseFloat(row.quantity) : 0;
      return toDec(priceAfterDisc * quantity);
    });

    const price = afterPricesTotals
      .map((row) => row)
      .reduce((a, b) => {
        return parseFloat(a) + parseFloat(isNaN(b) ? 0 : b);
      }, 0);
    return isNaN(price) ? 0 : limitTofourDecimal(price);
  }

  return {
    calculateSinglePackedUnits,
    calcDiffSize,
    calcDiffLength,
    calcQuanity,
    limitTofourDecimal,
    toDec,
  };
}
